import { AccountDocument } from './account-document.model';
import { Horse } from './horse';
import { AccountMembership } from './membership.model';

export class Account {
  id: number;
  emailAddress: string = '';
  male: boolean;
  firstName: string = '';
  lastName: string = '';
  displayName: string = '';
  profilePicFileName: string;
  birthDate: string = '';
  phone: string = '';
  streetAddress: string = '';
  city: string = '';
  state: string;
  zip: string = '';
  country: string = '';
  stripeCustomerId?: string;
  stripeCustomerId_Test?: string;
  createdOn?: string;
  memberships?: AccountMembership[];
  horses?: Horse[];

  birthCertificateUploadedOn?: string;
  taxDocumentUploadedOn?: string;
  taxDocumentFileName?: string;
  birthCertificateFilename?: string;
  documents?: AccountDocument[];
  roles: any[] = [];

  isActive: boolean;
}

export interface SearchAccountsRequest {
  query: string;
  organizationId: number;
  rodeoId: number;
  rodeoEventId: number;
  schedule: string;
  hasTaxDoc: boolean,
  missingTaxDoc: boolean,
  hasBirthCert: boolean,
  missingBirthCert: boolean,
  showActive: boolean;
  showInactive: boolean;
  pageNumber: number;
  pageSize: number;
  sortColumn: SearchAccountSortColumn;
  isAscending: boolean;
  hasOutstandingOrder: boolean;
  hasMembership: boolean;

  hasDocIds: number[];
  missingDocIds: number[];
  orgIds: number[];
}

export enum SearchAccountSortColumn {
  Id,
  EmailAddress,
  FirstName,
  LastName,
  CreatedOn,
  BirthDate,
  TaxDocument,
  BirthCertificate
}

export interface SearchAccountsResponse {
  accounts: Account[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
}

export class SearchDocumentsRequest {
  accountIds: number[];
  hasDocIds: number[];
  missingDocIds: number[];
  orgIds: number[];

  pageNumber: number;
  pageSize: number;
  sortColumn: SearchDocumentsColumn;
}

export enum SearchDocumentsColumn {
  Id,
  EmailAddress,
  FirstName,
  LastName
}

export interface SearchDocumentsResponse {
  documents: AccountDocument[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
}
